import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Paper, PaperProps } from '@mui/material';
import { opacity } from '../AppTheme/themePrimitives';

export type SurfaceSectionProps = PaperProps;

const SurfaceSection = React.forwardRef<HTMLDivElement, SurfaceSectionProps>(
    function SurfaceSection({ children, sx, variant = 'outlined', ...paperProps }, ref) {
        const theme = useTheme();

        return (
            <Paper
                ref={ref}
                {...paperProps}
                variant={variant}
                sx={{
                    width: '100%',
                    height: '100%',
                    padding: {
                        xs: 1,
                        md: 1.5,
                    },
                    backgroundColor: theme.palette.mode === 'dark'
                        ? alpha(theme.palette.background.paper, 0.7)
                        : alpha(theme.palette.background.default, 0.6),
                    borderRadius: theme.shape.borderRadius * 1.25,
                    borderColor: alpha(theme.palette.common.white, opacity.borderSubtle),
                    ...sx,
                }}
            >
                {children}
            </Paper>
        );
    }
);

export default SurfaceSection;
